/* スクロールに応じて要素を「フワッ」と表示。(IntersectionObserverを使った実装) */
// 少し遅延させて表示させる要素も制御。
const intersectionObserver = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      // 'js-in-view-delay' クラスを持つ要素の場合、0.4秒遅延させる
      if (entry.target.classList.contains("js-in-view-delay")) {
        setTimeout(() => {
          entry.target.classList.add("is-in-view");
        }, 400); // 0.4秒遅延
      } else {
        // 遅延させずに 'is-in-view' クラスを追加
        entry.target.classList.add("is-in-view");
      }
    } else {
      // 要素が視界から外れたら 'is-in-view' クラスを削除
      // entry.target.classList.remove("is-in-view");
    }
  });
});

// 遅延なしでフワッと表示させたい要素
const inViewItems = document.querySelectorAll(".js-in-view");
inViewItems.forEach(function (inViewItem) {
  intersectionObserver.observe(inViewItem);
});

// 0.4秒遅延してフワッと表示させたい要素
const inViewItemsDelay = document.querySelectorAll(".js-in-view-delay");
inViewItemsDelay.forEach(function (inViewItem) {
  intersectionObserver.observe(inViewItem);
});

